import HttpClientToken from '../../services/HttpClientToken';

import { defaultRol, RolProps } from '../../interfaces/catalogos/RolInterface';

export const Rol = () => {

    return new Promise<RolProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Rol/', token)
            .then( ({ data } : { data : RolProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerRoles = () => {

    return new Promise<RolProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Rol/ObtenerRoles', token)
            .then( ({ data } : { data : RolProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarRol = ( params: RolProps ) => {

    return new Promise<RolProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Rol/Actualizar', params, token)
            .then( ({ data } : { data : RolProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultRol } );
            });

        }

    });

}

export const AgregarRol = ( params: RolProps ) => {

    return new Promise<RolProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Rol/Agregar', params, token)
            .then( ({ data } : { data : RolProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultRol } );
            });

        }

    });

}
